// http://jfbastien.github.io/papers/Math.signbit.html
var $export = require('./_export');

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es7.math.signbit.js
// module id = 523
// module chunks = 2